module.exports = function init_login_popup() {

  const login_trigger = document.querySelector('#member-menu .log-in a');
  if(login_trigger) {
    login_trigger.addEventListener('click', function() {
      const login_popup = document.querySelector('#login-popup');
      login_popup.classList.add('active');
    });
  }

  const login_pu_close = document.querySelector('#login-popup .close');
  if(login_pu_close) {
    login_pu_close.addEventListener('click', function() {
      close_login_popup();
    });
  }

  const login_pu = document.querySelector('#login-popup');
  if(login_pu) {
    login_pu.addEventListener('click', function(e) {
      if (e.target === login_pu) {
        close_login_popup();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      close_login_popup();
    }
  });

  function close_login_popup() {
    const login_popup = document.querySelector('#login-popup');
    if(login_popup && login_popup.classList.contains('active')) {
      login_popup.classList.remove('active');
    }
  }
}

